import { useCart } from 'lib/core/hooks'
import { trackOrder, renderTrackingPixel } from 'modules/listrak/utils'
import { useEffect } from 'react'
import { useListrakReady } from '../useListrakReady'

export const useListrakConversion = (orderId: string | number) => {
  const { cart } = useCart()
  const { isLoaded } = useListrakReady()
  const cartData = cart?.data

  useEffect(() => {
    if (!isLoaded || !cartData) {
      return
    }

    const { amount: shippingAmount } = cartData.shippingAddress?.selectedShippingMethod ?? {}

    trackOrder({
      email: cartData.email,
      firstName: cartData.billingAddress?.firstName ?? '',
      lastName: cartData.billingAddress?.lastName ?? '',
      orderNumber: `${orderId}`,
      itemTotal: cartData.prices.subtotalExcludingTax.value.toString(),
      shippingTotal: shippingAmount ? shippingAmount.value.toString() : '0',
      taxTotal: `${cartData.prices.subtotalIncludingTax.value - cartData.prices.subtotalExcludingTax.value}`,
      handlingTotal: '0',
      orderTotal: cartData.prices.grandTotal.value.toString(),
      products: cartData.items.map(cartItem => {
        return {
          price: cartItem.prices.price.value.toString(),
          quantity: cartItem.quantity,
          sku: cartItem.product.sku
        }
      })
    })
    // eslint-disable-next-line
  }, [isLoaded])

  return {
    renderTrackingPixel
  }
}
